import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataTechnicalOwner } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import { useSelector } from 'react-redux';
import { dispatchCustomEvent } from 'tools/events';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function TechnicalOwner(props: IElementDataTechnicalOwner) {
    const {
        technicalOwner: technicalOwnerName = '',
        technicalOwnerEmail = '',
        ownerEmailSubject = '',
        showOwnerIcon = true,
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'technical_owner';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    const ownersConfiguration = useSelector((state: any) => state.auth.configuration.owners);
    const isAppPanel = settings?.isAppPanel;

    if (!fieldMetadataDisplay || !technicalOwnerName) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel
                icon={showOwnerIcon ? { type: 'mi', value: 'user' } : undefined}
                iconIndent={!showOwnerIcon}
            >
                {ownersConfiguration.technical_owner.label}
            </ElementDataRowLabel>
            <ElementDataRowValue>
                {isAppPanel ? (
                    <Box
                        component={'span'}
                        sx={{
                            color: 'primary.main',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            dispatchCustomEvent('mi-concierge-panel', {
                                action: 'owner-click',
                                payload: {
                                    userType: ownersConfiguration.technical_owner.label,
                                    userName: technicalOwnerName,
                                    userMail: technicalOwnerEmail,
                                },
                            });
                        }}
                    >
                        {technicalOwnerName}
                    </Box>
                ) : (
                    <>
                        {technicalOwnerEmail ? (
                            <Box
                                component={'a'}
                                href={`mailto:${technicalOwnerEmail}${ownerEmailSubject ? '?subject=' + ownerEmailSubject : ''}`}
                            >
                                {technicalOwnerName}
                            </Box>
                        ) : (
                            <Box component={'span'}>{technicalOwnerName}</Box>
                        )}
                    </>
                )}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
